import { useEffect } from 'react';
import cookie from 'react-cookies';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { ESIA_COOKIE } from '~/src/constants';
import { initialize } from '~/src/features/lk/PassportUpdate/store/thunks/initialize';
import { updatePassportData } from '~/src/features/lk/PassportUpdate/store/thunks/updatePassportData';
import { TState } from '~/src/store';

/**
 * Проверяет необходимость обновления данных пользователя
 * обновляет данные пользователя, по коду из Госуслуг
 * @param usePassportUpdateAbn - аб-тест, включает/отлкючает функционал обновления
 */
export const useUpdatePassportData = (usePassportUpdateAbn: boolean) => {
    const esiaKey = cookie.load(ESIA_COOKIE);

    const dispatch = useDispatch();

    const { isAuth, status, isLoading } = useSelector((state: TState) => {
        return ({
            isAuth: state.auth.isAuth,
            status: state.passportUpdate.status,
            isLoading: state.passportUpdate.isLoading,
        });
    }, shallowEqual);

    useEffect(() => {
        if (!isAuth || !usePassportUpdateAbn) {
            return;
        }

        if (esiaKey) {
            dispatch(updatePassportData(esiaKey));
            cookie.remove(ESIA_COOKIE);
        } else if (status === 'notInit' && !isLoading) {
            dispatch(initialize());
        }
    }, [isAuth, status, isLoading, esiaKey, usePassportUpdateAbn]);
};
